module.exports = __webpack_public_path__ + "static/media/Trash-can-large.e732d996.svg";